 
import { convertToZonedTimestamp } from "common/helpers/dateAndTimeHelpersV2"
import { getSummaryData, getGroupedSummaryData } from "./getSummaryData"
 
interface DataItemProps {
  [key: string]: unknown
}
export const getStartOfStamp = (stamp: string | number | Date, increment: string, props?: {timestamp_key?: string, tz?: string, is_end?: boolean}): string | undefined => {
 const { tz, timestamp_key } = props || {}
  
  increment = increment?.toLowerCase?.()
 
  let offsetter = '.'
  let offset = '000Z'

  if (typeof stamp === 'string' && stamp.includes('+00:00')) {
    stamp = new Date(stamp)?.toISOString() as string
  }

  const [ymd, t_off] = stamp?.split('T') || []
   
    if (typeof t_off === 'string') {
      if (t_off?.includes('-')) offsetter = '-'
      if (t_off?.includes('+')) offsetter = '+'
    }
     const [hm] = t_off?.split(offsetter) || []

    offset = t_off?.split(offsetter)?.[1] || offset
    offset = `${offsetter}${t_off?.split(offsetter)?.[1]}`    
 
    const [y,m,d] = ymd?.split('-') as string[]
    const [hh, mm] = hm?.split(':') as string[]
 
    let start_stamp = `${y}`
    if (['minute', 'minutes'].includes(increment)) start_stamp = `${y}-${m}-${d}T${hh}:${mm}:00`
    if (['hour', 'hours'].includes(increment)) start_stamp = `${y}-${m}-${d}T${hh}:00:00`
    if (['day', 'days'].includes(increment)) start_stamp = `${y}-${m}-${d}T00:00:00`
    if (['week', 'weeks'].includes(increment)) {
      const day_num = new Date(sortedData?.[0]?.[timestamp_key as string] as string | number | Date).getDay()
      const first_day = new Date(new Date(sortedData?.[0]?.[timestamp_key as string] as string | number | Date).setDate(Number(d) - day_num))
      const [f_ymd, ] = convertToZonedTimestamp(first_day, tz || 'UTC', 'yyyy-MM-dd hh-mm')?.split(' ') as string[]
      start_stamp = `${f_ymd}T00:00:00`
    }
    if (['month', 'months'].includes(increment)) start_stamp = `${y}-${m}-01T00:00:00`
    if (['year', 'years'].includes(increment)) start_stamp = `${y}-01-01T00:00:00`
 
    start_stamp = `${start_stamp}${offset}`
    return start_stamp
}

export const getEndOfStamp = (stamp: string | number | Date, increment: string, {tz}: {tz?: string}): string | undefined => {
  const new_start = getStartOfStamp(stamp, increment, {tz, is_end: true})
  let inc = 1000 // seconds
  if (!new_start) return
  if (['minute', 'minutes'].includes(increment)) inc = 60 * 1000
  if (['hour', 'hours'].includes(increment)) inc = 60 * 60 * 1000
  if (['day', 'days'].includes(increment)) inc = 60 * 60 * 24 * 1000
  if (['week', 'weeks'].includes(increment)) inc = 60 * 60 * 24 * 7 * 1000
  if (['month', 'months'].includes(increment)) inc = 60 * 60 * 24 * 30 * 1000
  if (['year', 'years'].includes(increment)) inc = 60 * 60 * 24 * 365 * 1000
  const new_end = new Date(new Date(new_start as string).getTime() + inc)
  return new_end?.toISOString?.()
}

export const getTimeGroupData = (dataArray: DataItemProps[], props?: Record<string, unknown>): Record<string, unknown> | Record<string, unknown>[] => {

  const {
    time_group,
    timestamp_key,
    timeZone,
    type,
    flatten,
    startOnly,
    endOnly,
    ...rest
   } = props || {}
   
    const flat_data = [] as DataItemProps[]

 
 
    if (type !== 'timestamps') {
      if (!time_group || !timestamp_key) return dataArray
    }
 
    let minute_int = 1
    const cv = time_group?.split(' ') || []
    const count = cv?.[0]
    let val = (cv?.[1] || 'Hours').toLowerCase()

    if (!val?.endsWith('s')) val = `${val}s`
    if (val === 'hours') minute_int = 60
    else if (val === 'days') minute_int = 60 * 24
    else if (val === 'weeks') minute_int = 60 * 24 * 7
    else if (val === 'months') minute_int = 60 * 24 * 30
    else if (val === 'years') minute_int = 60 * 24 * 365
 
    minute_int = minute_int * Number(count || 1)
 
    // in is in ms
    const int = minute_int * 60 * 1000
 
    const sortedData = [...dataArray].sort((a, b) => {
      const aTime = new Date(a?.[timestamp_key as string] as string | number | Date).getTime()
      const bTime = new Date(b?.[timestamp_key as string] as string | number | Date).getTime()
      return aTime - bTime
    })
 
    let offsetter = '.'
    let offset = '000Z'
    let stamp = rest?.start || rest?.timestamp || sortedData?.[0]?.[timestamp_key as string] as string | number | Date

    if (typeof stamp === 'string' && stamp.includes('+00:00')) {
      stamp = new Date(stamp)?.toISOString() as string
    }

    stamp = new Date(new Date(stamp as string | number).setMilliseconds(0)).toISOString() as string
    // check if stamp has +00:00 or -00:00 and convert to .000Z for offset, if so use that as the offset instead of the default
  //check if string includes +00:00 and if so change to .000Z

    const [ymd, t_off] = stamp?.split('T') || []
   
    if (typeof t_off === 'string') {
      if (t_off?.includes('-')) offsetter = '-'
      if (t_off?.includes('+')) offsetter = '+'
    }
     const [hm] = t_off?.split(offsetter) || []
    offset = t_off?.split(offsetter)?.[1] || offset
    
  

    offset = `${offsetter}${t_off?.split(offsetter)?.[1]}`    
 
    const [y,m,d] = ymd?.split('-') as string[]
    const [hh, mm] = hm?.split(':') as string[]
 
    let start_stamp = `${y}`
    if (val === 'minutes') start_stamp = `${y}-${m}-${d}T${hh}:${mm}:00`
    if (val === 'hours') start_stamp = `${y}-${m}-${d}T${hh}:00:00`
    if (val === 'days') start_stamp = `${y}-${m}-${d}T00:00:00`
    if (val === 'weeks') {
      const day_num = new Date(sortedData?.[0]?.[timestamp_key as string] as string | number | Date).getDay()
      const first_day = new Date(new Date(sortedData?.[0]?.[timestamp_key as string] as string | number | Date).setDate(Number(d) - day_num))
      const [f_ymd, ] = convertToZonedTimestamp(first_day, timeZone, 'yyyy-MM-dd hh-mm')?.split(' ') as string[]
      start_stamp = `${f_ymd}T00:00:00`
    }
    if (val === 'months') start_stamp = `${y}-${m}-01T00:00:00`
    if (val === 'years') start_stamp = `${y}-01-01T00:00:00`
 
    start_stamp = `${start_stamp}${offset}`
   
    const start = new Date(start_stamp)?.getTime() as string | number
    const end = new Date(rest?.end|| sortedData?.[sortedData.length - 1]?.[timestamp_key as string] as string | number | Date).getTime() + int

 
    const time_groups = []
    let grouped_data = {}

    const timestamps = [] as (string | number)[]
     
    
    for (let cur = start as number; cur <= (end - int); cur = cur + int) {
      const next = (cur + int)
      const new_id = `${cur}-${next}`
      time_groups.push(new_id)
      grouped_data = {...grouped_data, [new_id]: []}
    }

   
    
    sortedData?.forEach((item: DataItemProps) => {

      const time = new Date(item?.[timestamp_key as string] as string | number | Date).getTime()
      // find the index of the time group this item belongs in using index of because the groups are in order and non overlapping
      const group = time_groups?.find((group) => {
        const [start, end] = group?.split('-').map((x) => Number(x)) || []
        return time >= start && time < end
      })
    
      const new_item = {
        ...item, 
        time_group: `${startOnly ? start : endOnly ? end : group}`, 
        //[timestamp_key]: new Date(Number(group?.split('-')?.[0]) || '').toISOString(),
      } 
      if (!grouped_data?.[group as string]) grouped_data[group as string] = []
      grouped_data[group as string] = [...grouped_data[group as string], new_item]

      if (flatten) flat_data.push(new_item)
    })

  return [flatten ? flat_data : grouped_data, timestamps]
}

 
export const getTimeSummaryData =  (dataArray: DataItemProps[], props?: Record<string, unknown>): Record<string, unknown> | Record<string, unknown>[] => {
  const {
    
    flatten
  } = props || {}

  const [time_grouped_data] = getTimeGroupData(dataArray, {
    ...props,
    flatten: false
  })

  let time_summary_data = {}
  const flat_data = [] as Record<string, unknown>[]

  if (time_grouped_data) {
    Object.entries(time_grouped_data as Record<string, unknown>).forEach(([group, items]) => {
      if (!time_summary_data?.[group]) time_summary_data = { ...time_summary_data, [group]: {   group, ...getSummaryData(items as Record<string, unknown>[], {...props, totals_key: 'duration', flatten: true})} }
      flat_data.push({  group, ...getSummaryData(items as Record<string, unknown>[], {...props, totals_key: 'duration', flatten: true})})
    })
  }
  
  return flatten ? flat_data : time_summary_data
}